import ServiceNavigator from './ServiceNavigator'

export default ServiceNavigator
